// Section 24.7: the last 12 SeasonReports are kept in full; older ones are compacted to a
// SeasonSummary. Runs before the steady phase pushes this season's report, so it keeps 11.
import type { PhaseContext, ReportEntryKind, SeasonReport, SeasonSummary } from '../../core/types';

function summarise(report: SeasonReport): SeasonSummary {
  const entryCounts: Partial<Record<ReportEntryKind, number>> = {};
  for (const e of report.entries) entryCounts[e.kind] = (entryCounts[e.kind] ?? 0) + 1;
  return {
    turn: report.turn,
    year: report.year,
    season: report.season,
    population: report.population.end,
    births: report.population.births,
    deaths: report.population.deaths,
    fragility: report.fragility,
    entryCounts,
    keyEntries: report.entries.filter(
      (e) => e.kind === 'death' || e.kind === 'outcome' || e.kind === 'steady',
    ),
  };
}

export function compactHistory(ctx: PhaseContext): void {
  const keep = ctx.cfg.resources.historySeasons - 1;
  const history = ctx.draft.history;
  while (history.length > keep) {
    const oldest = history.shift();
    if (oldest !== undefined) ctx.draft.historySummaries.push(summarise(oldest));
  }
}
